import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  DropdownMenu,
  FilterButton,
  CalendarSmall,
  TFVButton,
  Translate,
} from '../../../Share/components';

const propTypes = {
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  ranges: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    key: PropTypes.string,
  }),
};

const defaultProps = {
  onChange: () => {},
  onClick: () => {},
  ranges: {
    startDate: moment().toDate(),
    endDate: moment().toDate(),
    key: 'selection',
  },
};

class DateRangeFilter extends Component {
  constructor(props) {
    super(props);
    const title = this.getDateRangeString();
    this.state = {
      title,
    };
  }

  getDateRangeString = () => {
    let dateRangeString = Translate({ content: 'main.dateRange' });
    const { ranges } = this.props;
    const start = moment(ranges.startDate);
    const end = moment(ranges.endDate);

    // Ensure start date is before or equal to end date
    if (start.isAfter(end)) {
      return dateRangeString; // Return default if dates are invalid
    }

    if (start.isSame(end, 'day')) {
      dateRangeString = start.locale('sv').format('DD MMMM');
    } else {
      dateRangeString = `${start.locale('sv').format('DD MMMM')}  -  ${end
        .locale('sv')
        .format('DD MMMM')}`;
    }
    return dateRangeString;
  };

  handleClick = () => {
    const title = this.getDateRangeString();
    this.setState({ title });
    if (this.filterElement && this.filterElement.onHiddenMenu) {
      this.filterElement.onHiddenMenu();
    }
    const { onClick } = this.props;
    onClick();
  };

  render() {
    const { onChange, ranges } = this.props;
    const { title } = this.state;

    // Validate ranges to ensure startDate is before or equal to endDate
    const validatedRanges = {
      startDate: moment(ranges.startDate).toDate(),
      endDate: moment(ranges.endDate).toDate(),
      key: ranges.key,
    };

    if (moment(validatedRanges.startDate).isAfter(validatedRanges.endDate)) {
      // Swap dates if startDate is after endDate
      [validatedRanges.startDate, validatedRanges.endDate] = [
        validatedRanges.endDate,
        validatedRanges.startDate,
      ];
    }

    const button = (
      <div className="tv-workassignment__date_picker">
        <div className="tv-workassignment__date_picker-title">
          {Translate({ content: 'myfilter.date' })}
        </div>
        <input
          className="tv-workassignment__date_picker-input"
          type="text"
          value={title}
          aria-label={Translate({ content: 'myfilter.date' })}
          readOnly
        />
        {/* <i className="tv-workassignment__date_picker-icon icon-arrow-more-2" /> */}
        {/* <FilterButton text={`${Translate({ content: 'status.filter' })}: <strong>${title}</strong>`}  */}
      </div>
    );
    return (
      <div className="tv-workassignment__control-panel tv-workassignment__filter-date-range">
        <DropdownMenu
          button={button}
          ref={(el) => {
            this.filterElement = el;
          }}
          tabIndex={-1}
          ariaLabel={Translate({
            content: 'myfilter.date',
          })}
        >
          <div className="tv-workassignment__filter-date-range__content">
            <CalendarSmall
              ranges={validatedRanges}
              onEventChange={onChange}
              showToggle={false}
              isMinDate={false}
            />
            <TFVButton
              type="secondary"
              onClick={this.handleClick}
              text={Translate({ content: 'general.ok' })}
            />
          </div>
        </DropdownMenu>
      </div>
    );
  }
}

DateRangeFilter.propTypes = propTypes;
DateRangeFilter.defaultProps = defaultProps;

export default DateRangeFilter;
